import React, { useState } from 'react';
import {useDispatch} from 'react-redux';
import {addToCart} from "../actions/actionCreators";
import { notification } from 'antd';

function Product({item}) {
    
    const [api, contextHolder] = notification.useNotification();
    const [qty, setQty] = useState(0);
    const [size, setSize] = useState(null);
    const dispatch = useDispatch();
    
    const setSizeData =(e)=>{
        setSize(e.target.value);
    }
    
    const setQtyData =(e)=>{
        setQty(e.target.value);
    }
    
    const addItem =()=>{
        if (qty > 0 && size !== null)
        {
            const data = {
                    id: item.id
                    ,unitName: item.unitName
                    ,qty: parseInt(qty)
                    ,size
                    ,cost: parseFloat(item.cost)
            };
            dispatch(addToCart(data));  
            
            api.info({
                  message: `Item added`,
                  description:`${qty} ${item.unitName} added to shopping cart`,
                  placement: 'bottomLeft',
            });
            
        } 
        else
        {
            api.error({
                  message: `Item not added`,
                  description:`qty or size not selected`,
                  placement: 'bottomLeft',
            });
        }
    }
    
  return (
        <>        
      {contextHolder}
        <div className="box p-3 mb-5">
            <div className="row justify-content-center">   
                <img src={item.img}/> 
            </div>  
            <div className="price d-flex justify-content-center mb-1">   
                  ${item.cost}
            </div>  
            <div className="d-flex justify-content-around">   
                <div className="col">  
                  <select name="qty" className="lselect" defaultValue='default' onChange={setQtyData}>
                    <option value='default' disabled>qty</option>
                    <option>1</option>
                    <option>2</option>
                    <option>3</option>
                    <option>4</option>
                    <option>5</option>
                    <option>6</option>
                    <option>7</option>
                    <option>8</option>
                    <option>9</option>
                    <option>10</option>
                  </select>
                </div> 
                <div className="col">  
                  <select name="size" className="lselect" defaultValue='default' onChange={setSizeData}>
                    <option value='default' disabled>size</option>
                    <option>xs</option>
                    <option>s</option>
                    <option>m</option>
                    <option>l</option>
                    <option>xl</option>
                  </select>
                </div>
                <div className="col">  
                    <button className="primary-btn white-bg" onClick={addItem}><span className="mr-10">Add</span></button>
                </div>
            </div>
        </div> 
    </>
  );
}

export default Product;
